"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SokoSiteAttachmentsView = exports.enhance = exports.sortByOptionsLens = exports.mapDispatchToProps = exports.PAGINATION_OPTIONS = void 0;
var monocle = require("monocle-ts");
var React = require("react");
var Types = require("types");
var FilesActions = require("@caddigital/sok-reducers/lib/actions/files");
var sokositeActions = require("@caddigital/sok-reducers/lib/actions/sokosite/current");
var ViewHeader_1 = require("./ViewHeader");
var ListHeader_1 = require("./ListHeader");
var ListRow_1 = require("./ListRow");
var Tools_1 = require("./Tools");
var react_redux_1 = require("react-redux");
var FilesRouter_1 = require("../../../routers/FilesRouter");
var viewport_1 = require("reducers/viewport");
var recompose_1 = require("recompose");
var translate_1 = require("utils/translate");
exports.PAGINATION_OPTIONS = [350, 700, 1400];
var mapDispatchToProps = function (dispatch) { return ({
    fetchSchema: function (id) { return dispatch(FilesActions.fetchSchema(id)); },
    fetchFolder: function (folderId, sortByOptions, searchOptions) {
        return dispatch(FilesActions.fetchFiles(folderId, sortByOptions, searchOptions));
    },
    fetch: function (id, isMeter) {
        if (isMeter === void 0) { isMeter = false; }
        return dispatch(sokositeActions.fetchRequest(id, isMeter));
    }
}); };
exports.mapDispatchToProps = mapDispatchToProps;
var mapStateToProps = function (state) {
    var selectedLanguage = (0, translate_1.getLanguage)();
    return {
        currentFolder: state.files.currentFolder,
        router: state.router,
        properties: state.files.filesFolderProperties,
        fileSelections: state.files.selectedItems,
        fileList: state.files.fileList,
        data: state.files.data,
        folderPath: state.files.folderPath,
        bid: state.bid.current,
        metadata: state.files.metadata,
        viewport: state.viewport.size,
        // Searching
        searchOptions: state.files.searchOptions,
        searchData: state.files.searchData,
        // Toggled States
        filtersDropdownToggled: state.files.filtersDropdownToggled,
        columnsDropdownToggled: state.files.columnsDropdownToggled,
        sortDropdownToggled: state.files.sortDropdownToggled,
        cartToggled: state.cart.toggled,
        mobileSearchOverlayToggled: state.files.mobileSearchOverlayToggled,
        advancedSearchDropdownToggled: state.files.advancedSearchDropdownToggled,
        searchDropdownToggled: state.files.searchDropdownToggled,
        // Sorting
        sortByOptions: state.files.sortByOptions,
        cartSelectionsLength: state.cart.data.items.length,
        filesSelectionLength: state.files.data.status === 'FETCHED'
            ? state.files.selectedItems.length
            : 0,
        isFetching: state.files.data.status !== 'FETCHED' &&
            state.files.data.status !== 'FAILED',
        isMobile: (0, viewport_1.isMobile)(state.viewport),
        selectedLanguage: selectedLanguage,
        token: state.auth.current.token,
        selectedFileType: state.files.searchOptions.searchFileType,
        filtering: state.files.searchOptions.filtering
    };
};
var statePropsExtractable = Types.extractReturnType(mapStateToProps);
var dispatchPropsExtractable = Types.extractReturnType(exports.mapDispatchToProps);
exports.sortByOptionsLens = monocle.Lens.fromProp('sortByOptions');
exports.enhance = (0, recompose_1.compose)((0, react_redux_1.connect)(mapStateToProps, exports.mapDispatchToProps), (0, recompose_1.lifecycle)({
    componentWillMount: function () {
        var props = this.props;
        props.fetch(props.match.params.sokositeObjectUuid, props.isMeter);
        if (!this.props.match.params.folderId) {
            return;
        }
        var folderId = parseInt(this.props.match.params.folderId, 10);
        props.fetchFolder(folderId, props.sortByOptions, props.searchOptions);
        props.fetchSchema(folderId);
    }
}), recompose_1.pure);
exports.SokoSiteAttachmentsView = (0, exports.enhance)(function (props) {
    if (!props.currentFolder)
        return null;
    var metadata = __assign(__assign({}, props.metadata), { list: props.metadata.list.filter(function (columnMeta) { return columnMeta.identifier !== 'description-meta'; }) });
    return (React.createElement(FilesRouter_1.default, __assign({}, props, { BreadCrumb: props.BreadCrumb, ListHeader: ListHeader_1.ListHeader, ListRow: ListRow_1.ListRow, staticIconCount: 4, staticIconCountMobile: 3, Tools: Tools_1.FileListTools, ViewHeader: ViewHeader_1.default, selectedLanguage: props.selectedLanguage, rootFolder: props.currentFolder, showFolderTree: false, metadata: metadata })));
});
exports.default = exports.SokoSiteAttachmentsView;
